// Machine-authored for Phase 7d; requires review by a native Arabic speaker.
const users = {
  listTitle: "مسئولو الحسابات",
  listSubtitle: "إدارة المسؤولين المرتبطين بكل حساب شركة.",
  addAdmin: "إضافة مسؤول",
  stats: {
    title: "إحصاءات مسؤولي الحسابات",
    accounts: "الشركات",
    active: "المسؤولون النشطون",
    inactive: "المسؤولون غير النشطين",
    admins: "إجمالي المسؤولين",
    loading: "جارٍ التحميل",
    error: "غير متاح",
  },
  filters: {
    title: "تصفية المسؤولين",
    search: "بحث",
    searchPlaceholder: "بحث",
    status: "الحالة",
    allStatuses: "كل الحالات",
    archivedAt: "تاريخ الأرشفة",
    archivedAtPlaceholder: "اختر نطاقاً زمنياً",
    clearDateRange: "مسح النطاق الزمني",
  },
  datePicker: {
    nextMonth: "الشهر التالي",
    previousMonth: "الشهر السابق",
  },
  table: {
    name: "المسؤول",
    username: "اسم المستخدم",
    email: "البريد الإلكتروني",
    company: "الشركة",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    archivedAt: "تاريخ الأرشفة",
    actions: "الإجراءات",
    empty: "لا يوجد مسؤولو حسابات مطابقون لهذه التصفية.",
    error: "تعذر تحميل مسؤولي الحسابات.",
    loading: "جارٍ تحميل مسؤولي الحسابات",
    showingCount: "عرض {{count}} من {{total}}",
    rowsPerPageLabel: "عرض الصفوف",
    nextPage: "الصفحة التالية",
    previousPage: "الصفحة السابقة",
    pagination: "ترقيم الصفحات",
    sortAscending: "ترتيب تصاعدي",
    sortDescending: "ترتيب تنازلي",
  },
  status: {
    active: "نشط",
    inactive: "غير نشط",
    pendingActivation: "بانتظار التفعيل",
  },
  actionMenu: {
    trigger: "إجراءات المسؤول",
  },
  actions: {
    view: "عرض",
    edit: "تعديل",
    delete: "حذف",
    resendActivation: "إعادة إرسال التفعيل",
    restore: "استعادة",
  },
  archivedAdmins: {
    title: "أرشيف مسؤولو الحسابات",
    subtitle: "المسؤولون الذين تمت أرشفتهم ويمكن استعادتهم.",
    empty: "لا يوجد مسؤولو حسابات مؤرشفون مطابقون لهذه التصفية.",
  },
  form: {
    createTitle: "إضافة مسؤول حساب",
    editTitle: "تعديل مسؤول الحساب",
    createSubtitle: "أدخل بيانات المسؤول واربطه بشركة.",
    editSubtitle: "تحديث بيانات المسؤول.",
    mainInformation: "المعلومات الأساسية",
    fullNameHelper: "يجب أن يكون الاسم ثلاثياً",
    nameEn: "الاسم بالإنجليزية",
    nameAr: "الاسم بالعربية",
    username: "اسم المستخدم",
    email: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    company: "الشركة",
    companyPlaceholder: "اختر شركة",
    countrySelectAriaLabel: "رمز الدولة",
    isActive: "نشط",
    isActiveDescription: "لا يمكن للمسؤولين غير النشطين تسجيل الدخول.",
    statusDialog: {
      titleActivate: "تفعيل المسؤول",
      titleDeactivate: "إلغاء تفعيل المسؤول",
      questionActivate: "هل أنت متأكد أنك تريد تفعيل هذا المسؤول؟",
      questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل هذا المسؤول؟",
      note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
      yes: "نعم",
      no: "لا",
      close: "إغلاق نافذة تغيير الحالة",
    },
    countries: {
      ksa: "المملكة العربية السعودية",
      egypt: "جمهورية مصر العربية",
      uae: "الإمارات العربية المتحدة",
      jordan: "المملكة الأردنية الهاشمية",
    },
    submitCreate: "إنشاء المسؤول",
    submitEdit: "حفظ التغييرات",
    cancel: "إلغاء",
    loading: "جارٍ تحميل بيانات المسؤول",
    loadError: "تعذر تحميل بيانات المسؤول.",
    empty: "تعذر العثور على هذا المسؤول.",
    createSuccessFallback: "تم الإنشاء بنجاح",
  },
  restoreDialog: {
    title: "استعادة المسؤول",
    question: "يوجد مسؤول بنفس المعلومات في أرشيف المسؤولين",
    prompt: "هل تريد استعادة هذا المسؤول مرة أخرى؟",
    cancel: "إلغاء",
    confirm: "استعادة المسؤول",
    close: "إغلاق نافذة الاستعادة",
    successFallback: "تمت استعادة المسؤول بنجاح.",
    errorFallback: "تعذرت استعادة المسؤول.",
  },
  restoreArchivedAdminDialog: {
    title: "استعادة مدير حساب",
    question: "هل أنت متأكد من استعادة مدير الحساب؟",
    prompt: "سيصبح مدير الحساب نشطاً مرة أخرى ويمكن استخدامه في النظام.",
    cancel: "الغاء",
    confirm: "استعادة مدير الحساب",
    close: "إغلاق نافذة الاستعادة",
    successFallback: "تمت استعادة المسؤول بنجاح.",
    errorFallback: "تعذرت استعادة المسؤول.",
  },
  validation: {
    usernameInvalid:
      "يجب أن يتكون اسم المستخدم من 3 إلى 30 حرفاً، ويحتوي على حروف وأرقام ونقاط وشرطات سفلية أو عادية فقط.",
    phoneRequired: "رقم الهاتف مطلوب.",
    phoneInvalid: "يرجى إدخال رقم هاتف صحيح.",
  },
  detail: {
    loading: "جارٍ تحميل بيانات المسؤول",
    error: "تعذر تحميل بيانات المسؤول.",
    empty: "تعذر العثور على هذا المسؤول.",
    mainInformation: "المعلومات الأساسية",
    profileTitle: "الملف الشخصي",
    accountDetailsTitle: "تفاصيل مديري الحساب",
    fullName: "الاسم الكامل",
    activationStatus: "حالة التفعيل",
    username: "اسم المستخدم",
    email: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    company: "الشركة",
    status: "الحالة",
    twoFactor: "المصادقة الثنائية",
    twoFactorEnabled: "مفعّلة",
    twoFactorDisabled: "غير مفعّلة",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "آخر تحديث",
    back: "العودة إلى المسؤولين",
    editAction: "تعديل",
    deleteAction: "حذف",
    resendActivationAction: "إعادة إرسال التفعيل",
    deleteTitle: "هل تريد حذف هذا المسؤول؟",
    deleteDescription: "هذا الإجراء دائم ولا يمكن التراجع عنه.",
    confirmDelete: "حذف",
    cancelDelete: "إلغاء",
    closeDelete: "إغلاق",
    resendTitle: "إعادة إرسال رابط التفعيل؟",
    resendDescription:
      "سيتم إرسال رابط تفعيل جديد إلى البريد الإلكتروني للمسؤول.",
    confirmResend: "إعادة الإرسال",
    cancelResend: "إلغاء",
    closeResend: "إغلاق",
  },
};

export default users;
